<template>
  <v-content>
    <v-container fluid fill-height grid-list-sm pa-0>
      <v-layout column>
        <v-flex fill-height>
          <v-layout column class="login-background-color">
            <v-flex>
              <v-layout align-center justify-center ma-3>
                <v-flex xs12 sm7 md3 class="box-login">
                  <v-form @submit.prevent="login" novalidate>
                    <v-card class="elevation-3">
                      <v-card-text class="pl-3 pr-3 pb-1 pt-0">
                        <v-layout column>
                          <v-flex pt-3>
                            <img src="/static/logo_ciclos.png" class="img-logo" alt="logo">
                          </v-flex>
                          <v-flex pt-3 align-center class="title-access primary--text headline">
                            ACESSE SUA CONTA
                          </v-flex>
                          <v-flex pt-4>
                              <v-text-field :label="$t('attributes.email')" name="email"
                                v-model="credentials.email"
                                :counter="100"
                                :error-messages="valdationErrors.email">
                              </v-text-field>
                              <v-text-field :label="$t('attributes.password')" name="password"
                                type="password"
                                v-model="credentials.password"
                                :error-messages="valdationErrors.password"
                                :counter="20">
                              </v-text-field>
                          </v-flex>
                        </v-layout>
                        <v-flex>
                          <v-btn color="primary" block type="submit" name="loginButton">{{$t('views.actions.in')}}</v-btn>
                          <v-btn flat block @click="showModal = true" color="primary">{{$t('views.fields.login.resetPassword')}}</v-btn>
                        </v-flex>
                      </v-card-text>
                    </v-card>
                  </v-form>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
        </v-flex>
        <recover-password-dialog lazy="true" v-model="showModal"></recover-password-dialog>
      </v-layout>
    </v-container>
  </v-content>
</template>
<script>
import RecoverPasswordDialog from './RecoverPasswordDialog';
import AuthService from './AuthService';

export default {
  name: 'login',
  components: {
    RecoverPasswordDialog,
  },
  data() {
    return {
      roles: [],
      valdationErrors: [],
      showModal: false,
      credentials: {
        email: '',
        password: '',
      },
    };
  },
  methods: {
    login() {
      AuthService.login(this.credentials).then(() => {
        this.$router.replace({
          name: 'dashboard',
        });
      }).catch((error) => {
        this.valdationErrors = error.response.data;
      });
    },
  },
};
</script>
<style>
  .application--wrap {
    background-color: #0d47a1;
  }
  .no-border-radius {
    border-radius: unset !important;
  }
  .bottom-fix {
    position: absolute;
    bottom: 0;
    min-width: 100%;
  }
  .img-z-index {
    z-index: 9999;
  }
  .no-z-index {
    z-index: 0;
  }
  .img-logo {
    width: 100%;
  }
  .title-access {
    border-bottom: 1px solid #CCC;
    font-weight: 500;
    text-align: center;
  }
  .box-login {
    margin-top: 10%;
  }
</style>



// WEBPACK FOOTER //
// src/features/auth/Login.vue